import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgBadgeModule } from '../pg-badge/pg-badge.module';
import { PgBubbleModule } from '../pg-bubble/pg-bubble.module';
import { PgButtonModule } from '../pg-button/pg-button.module';
import { PgCalendarModule } from '../pg-calendar/pg-calendar.module';
import { PgCardModule } from '../pg-card/pg-card.module';
import { PgCheckboxModule } from '../pg-checkbox/pg-checkbox.module';
import { PgContentBlocksModule } from '../pg-content-blocks/pg-content-blocks.module';
import { PgDropDownModule } from '../pg-drop-down/pg-drop-down.module';
import { PgFieldModule } from '../pg-field/pg-field.module';
import { PgIconModule } from '../pg-icon/pg-icon.module';
import { PgLinearLoaderModule } from '../pg-linear-loader/pg-linear-loader.module';
import { PgListSelectModule } from '../pg-list-select/pg-list-select.module';
import { PgNotificationModule } from '../pg-notification/pg-notification.module';
import { PgRadioModule } from '../pg-radio/pg-radio.module';
import { PgSelectModule } from '../pg-select/pg-select.module';
import { PgSliderModule } from '../pg-slider/pg-slider.module';
import { PgSpinnerModule } from '../pg-spinner/pg-spinner.module';
import { PgSwitchModule } from '../pg-switch/pg-switch.module';
import { PgTopbarModule } from '../pg-topbar/pg-topbar.module';
import { PgFormModule } from '../pg-form/pg-form.module';
import { GritOverlayModule } from '../grit-overlay/grit-overlay.module';
import { PgFlagNotificationComponent } from '../pg-notification/pg-flag-notification/pg-flag-notification.component';

@NgModule({
  declarations: [],
  exports: [
    PgBadgeModule,
    PgBubbleModule,
    PgButtonModule,
    PgCalendarModule,
    PgCardModule,
    PgCheckboxModule,
    PgContentBlocksModule,
    PgDropDownModule,
    PgFieldModule,
    PgIconModule,
    PgLinearLoaderModule,
    PgListSelectModule,
    PgNotificationModule,
    PgRadioModule,
    PgSelectModule,
    PgSliderModule,
    PgSpinnerModule,
    PgSwitchModule,
    PgTopbarModule,
    PgFormModule,
    GritOverlayModule,
  ],
  entryComponents: [PgFlagNotificationComponent],
  imports: [CommonModule],
})
export class GritCoreModule {}
